module.exports = __webpack_public_path__ + "static/media/papas-moving.30ae7812.jpg";